import { Component, ViewEncapsulation, OnInit, OnDestroy, AfterContentInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../core/services/authentication.service';
import { LanguageService } from '../../core/services/language.service';
import { PasswordValidation }    from '../../utils/password-validation.util';
import {HEADER_MENU_CLOSED, HEADER_MENU_OPENED} from "../../app.constants";
import {EventsService} from "../../core/services/events.service";

@Component({
  selector: 'registration-form',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegistrationComponent implements OnInit {
  title: string = 'REGISTRATION.TITLE';
  form: FormGroup;

  constructor (private authentication: AuthenticationService,
               private languageService: LanguageService,
               private toastr: ToastrService,
               private fb: FormBuilder,
               private eventBus: EventsService,
               private router: Router) {}

  ngOnInit () {
    this.form = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.minLength(2)]],
      street: ['', [Validators.required, Validators.minLength(2)]],
      postCode: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(9)]],
      city: ['', [Validators.required, Validators.minLength(2)]],
      country: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', Validators.email],
      password: ['', [Validators.minLength(6), Validators.required]],
      passwordConfirmation: ['', [Validators.minLength(6), Validators.required]]
    }, {
      validator: PasswordValidation.MatchPassword
    });

    setTimeout(() => this.eventBus.trigger(HEADER_MENU_OPENED));
  }

  ngOnDestroy () {
    this.eventBus.trigger(HEADER_MENU_CLOSED);
  }

  get firstName () {
    return this.form.get('firstName');
  }

  get lastName () {
    return this.form.get('lastName')
  }

  get street () {
    return this.form.get('street')
  }

  get postCode () {
    return this.form.get('postCode')
  }

  get city () {
    return this.form.get('city')
  }

  get country () {
    return this.form.get('country')
  }

  get email () {
    return this.form.get('email');
  }

  get password () {
    return this.form.get('password');
  }

  get passwordConfirmation () {
    return this.form.get('passwordConfirmation');
  }

  hasError(model:FormControl) {
    return model.invalid && (model.dirty || model.touched)
  }

  markAsDirty () {
    const controls = this.form.controls;

    for (let control in controls) {
      if (
        controls.hasOwnProperty(control) &&
        controls[control].invalid
      ) {
        controls[control].markAsDirty();
      }
    }
  }

  signUp ($event) {
    $event.preventDefault();

    if (this.form.invalid) {
      return this.markAsDirty();
    }

    this.authentication
      .signUp(this.form.getRawValue())
      .then((response) => {
        this.toastr.success(this.languageService.translate('MESSAGES.REGISTRATION_SUCCESS'), 'Success');
        this.router.navigate([{outlets: { popup: null}}]);
      })
      .catch(err => {
        let controls = this.form.controls;
        for (let error in err.error.errors) {
          if (error === 'first_name') controls.firstName.setErrors({'incorrect': true});
          if (error === 'last_name') controls.lastName.setErrors({'incorrect': true});
          if (error === 'street') controls.street.setErrors({'incorrect': true});
          if (error === 'post_code') controls.postCode.setErrors({'incorrect': true});
          if (error === 'city') controls.city.setErrors({'incorrect': true});
          if (error === 'country') controls.country.setErrors({'incorrect': true});
          if (error === 'email') controls.email.setErrors({'incorrect': true});
          if (error === 'password') controls.password.setErrors({'incorrect': true});
        }
        this.toastr.error(err.error.message, 'Error');
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/popups/registration/registration.component.ts